<div class="row">
    <div class="col-md-6">
        <h1><span *ngIf="!editData">Crear Contrato</span><small *ngIf="editData">Editando contrato #{{ editData.id }}</small></h1>
    </div>
    <div class="col-6 ">
        <div style="text-align: right" *ngIf="!editData">
          <button type="button" class="btn btn-secondary" (click)="emptyDataStore()">
              Vaciar
          </button>
        </div>
      </div>
</div>
<form [formGroup]="contract" class="form-horizontal" (ngSubmit)="createContract()" (keydown.enter)="$event.preventDefault()" autocomplete="off">
<div class="row">
    <div class="col-md-8 mb-4">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">

                        <app-select-company [companyId]="saveData?.compServicioId" (formReady)="addChildForm('select-company', $event)"></app-select-company>

                    </div>
                    <div class="col-md-6" *ngIf="userRole == 'admin'">

                        <app-select-producer [idProducer]="saveData?.idProducer" (formReady)="addChildForm('select-producer', $event)"></app-select-producer>

                    </div>

                    <div class="col-md-6">
                        <label class="form-labels mt-4">¿Como se enteró?</label>
                        <select class="form-select" formControlName="comoSeEntero">
                            <option value="google">Google</option>
                            <option value="redes sociales">Redes Sociales</option>
                            <option value="referido">Referido</option>
                            <option value="billboard">Billboard</option>
                            <option value="flyer">Flyer</option>
                            <option value="otro">Otro</option>
                        </select>
                    </div>

                    <div class="col-md-6">
                        <label class="form-labels mt-4">Garantía</label><br/>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" value="true" formControlName="garantia">
                            <label class="form-check-label">Si</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input"  formControlName="garantia"  type="radio" value="false">
                            <label class="form-check-label">No</label>
                          </div>
                    </div>

                    

                    <div class="col-md-12">
                        <label class="form-labels mt-4">Propósito</label>
                        <div class="input-group">
                            <input type="text" class="form-control" formControlName="proposito">
                        </div>
                    </div>
                    

                    <app-applicant [solicitante]="saveData?.solicitante" (formReady)="addChildForm('solicitante', $event)"></app-applicant>


                    <!-- <app-address (formReady)="addChildForm('address1', $event)"></app-address>


                    <app-employer-info (formReady)="addChildForm('employer', $event)"></app-employer-info> -->

                   
                    <app-cosigner [coSolicitante]="saveData?.coSolicitante" (formReady)="addChildForm('coSolicitante', $event)"></app-cosigner>
                    

                    <app-references [editReferences]="saveData?.referenciasJson" (formReady)="addChildForm('referenciasJson', $event)"></app-references>


                    <app-collaterals [isLoan]="isLoan" [colaterals]="saveData?.colaterals" (formReady)="addChildForm('colaterals', $event)"></app-collaterals>


                    
                     <app-guarantor *ngIf="isLoan" [editGarantizador]="saveData?.garantizador" (formReady)="addChildForm('garantizador', $event)"></app-guarantor>
                    

                    <app-assets *ngIf="isLoan" [editBienesJson]="saveData?.bienesJson" (formReady)="addChildForm('bienesJson', $event)" ></app-assets>

                    <div class="col-md-12" *ngIf="!isLoan">
                        <hr>
                        <label class="form-labels mt-4">Desglose del desembolso</label>
                        <div class="input-group">
                            <textarea class="form-control" formControlName="bienesJson"></textarea>
                        </div>
                    </div>

                    <div class="col-md-12 mt-4">
                        <hr/>
                    </div>
                    
                    <div class="col-md-12">
                        <!-- <input type="submit" *ngIf="!editData" [disabled]="contract.invalid" class="btn btn-primary mt-4" value="Crear Contrato">
                        <input type="submit" *ngIf="editData" [disabled]="contract.invalid" class="btn btn-primary mt-4" value="Guardar Contrato"> -->
                        <input type="submit" *ngIf="!editData" class="btn btn-primary mt-4" value="Crear Contrato">
                        <input type="submit" *ngIf="editData"  class="btn btn-primary mt-4" value="Guardar Contrato">
                    </div>
                    <!-- <a class="btn" (click)="showValidators()">show validators</a>
                    {{invalids}} -->
                    <div *ngIf="showMsg" style="padding-top: 10px; color:rgb(255, 62, 62)">{{ msg }}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4">
        <div class="card">
        <div class="card-body">
            <div class="row quote-res" *ngIf="quoteData">
                <div class="col-12 mt-4">
                    <label class="form-labels">Cantidad de Prestamo</label>
                     <br/><span class="amounts" >{{quoteData.cantidad | currency}}</span>
                </div>
                <div class="col-12 mt-4">
                    <label class="form-labels">Interes</label>
                     <br/><span class="amounts">{{quoteData.tasaInteresAnual }}%</span>
                </div>
                <div class="col-12 mt-4">
                    <label class="form-labels">Interes a pagar</label>
                     <br/><span class="amounts">{{quoteData.cargoFinanciamiento | currency }}</span>
                </div>
                <div class="col-12 mt-4">
                    <label class="form-labels">Total a pagar</label>
                     <br/><span class="amounts">{{quoteData.totalDePagos | currency }}</span>
                </div>
                <div class="col-12 mt-4">
                    <label class="form-labels">Pago mensual</label>
                     <br/><span class="amounts">{{quoteData.cantidadPagoMensual | currency }}</span>
                </div>
               <!--  <div class="col-12 mt-4">
                    <label class="form-labels">Interes a pagar</label>
                     <br/><span class="amounts">{{quoteData.totalInterest | currency}}</span>
                </div>
                <div class="col-12 mt-4" >
                    <label class="form-labels">Total a pagar</label>
                     <br/><span class="amounts">{{quoteData.totalPaid | currency }}</span>
                </div>
                <div class="col-12 mt-4">
                    <label class="form-labels">Termino</label>
                     <br/><span class="amounts">{{ quoteData.terms | currency }}</span>
                </div>

                <div class="col-12 mt-4">
                    <label class="form-labels">Fecha de pago</label>
                     <br/><span class="amounts">{{ quoteData.loanDate }}</span>
                </div>-->

            </div> 
            </div>
        </div>
    </div>
</div>
</form>

